module.exports = __webpack_public_path__ + "img/gallery-pic05.4694cd0d.jpg";